import React from "react";
import { RouteProps, Link } from "react-router-dom";
import { IForecast } from "../../../services/api/Forecast";
import Button from "../../../components/Form/Button";
import ItemBox from "../../../components/ItemBox";

interface GroupListProps extends RouteProps {
  data: IForecast[];
  year: Number;
  month: Number;
}

const GroupList: React.FC<GroupListProps> = ({ data, year, month }) => {
  function renderRow(forecast: IForecast) {
    return (
      <li key={forecast.groupId}>
        <ItemBox
          {...(forecast.children ? { className: "hasChildren" } : { className: forecast.status.slug })}
          name={forecast.groupName + " - " + forecast.groupCode}
        >
          {forecast.groupParentId ? (
            <Link
              to={
                "/forecast-update/" +
                forecast.groupId +
                "/" +
                year +
                "/" +
                month
              }
            >
              <Button className="box__edit" title="Details" />
            </Link>
          ) : null}
        </ItemBox>

        {forecast.children ? (
          <ul className="groups__list"> {forecast.children.map(renderRow)}</ul>
        ) : null}
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">{data.map(renderRow)}</ul>
    </React.Fragment>
  );
};

export default GroupList;
